/** @format */
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import ArrowRightIcon from '@toucan/client/global/icons/arrow-right.svg';

import { DEFAULT_TEST_ID } from './config/constants';
import { TimelineMarkerProps } from './config/types';
import { styles } from './timeline-marker.styles';

export * from './config/constants';
export type { TimelineMarkerProps } from './config/types';

const StyledTimelineMarker = styled.div`
    ${styles}
`;

export const TimelineMarker: FunctionComponent<TimelineMarkerProps> = ({
    modelName,
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    ...otherProps
}) => {
    const { t } = useTranslation();

    return (
        <StyledTimelineMarker data-testid={dataTestId} {...otherProps}>
            <span className="timeline-marker-text">
                <span className="timeline-marker-name">{modelName}</span>
                <span className="timeline-marker-label">
                    {t('You are here')}
                </span>
            </span>
            <span className="timeline-marker-circle" aria-hidden="true">
                <ArrowRightIcon />
            </span>
        </StyledTimelineMarker>
    );
};
